import { jsonApiVuex } from '@common/store/json-api-vuex';

export const integrationAmazonAdsConversionDefinitions = jsonApiVuex(
  'integrations/amazon-ads/conversion-definition',
  {},
  {}
);
